import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import Image from '../../assets/BannerCelfocus.jpg';
import { ReactComponent as VersionsIcon } from '../../assets/versions.svg';
import {Link} from 'react-router-dom';

const useStyles = makeStyles({
    grid: {
        fontFamily: 'SourceSansPro-Regular',
        height: 370,
        backgroundImage: `url(${Image})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
        backgroundSize: "cover"
    },
    body: {
        fontFamily: 'SourceSansPro-Regular',
        fontSize: 14,
    },
    tableContainer: {
        marginBottom: 40
    },
    releasesHeader: {
        textAlign: 'center',
        color: 'white'
    },
    containerBlock: {
        paddingTop: 105
    },
    h2: {
        fontFamily: 'Gotham-Book',
        fontSize: 32,
        letterSpacing: -1,
        color: 'white',
        padding: '0px 20px 10px 20px',
        textAlign: 'center'
    },
    table: {
        minWidth: 650,
        fontFamily: 'SourceSansPro-Regular'
    },
    link: {
        fontFamily: 'SourceSansPro-SemiBold',
        color: '#1f96a2',
        cursor: 'pointer'
    },
    patchRow: {
        backgroundColor: '#f5f5f5'
    },
    patchVersion: {
        paddingLeft: 40
    },
    toggleButton: {
        padding: 4,
        marginRight: 8,
        width: 32,
        height: 32
    },
    togglePlaceholder: {
        display: 'inline-block',
        width: 40,
        minWidth: 40
    },
    versionCell: {
        display: 'flex',
        alignItems: 'center'
    },
    patchIndent: {
        display: 'inline-block',
        width: 16
    }
});

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#262626",
        color: theme.palette.common.white
    },
    body: {
        fontSize: 14,
        fontFamily: 'SourceSansPro-Regular'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

export const OrderManagementReleaseVersion = () => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});

    useEffect(() => {
        fetch("/releases_order_management.json")
          .then((res) => res.json())
          .then(
            (data) => {
              setData(data.releases);
            },
            (error) => {
              console.log(error);
            }
          );
      }, []);

    const toggleRow = (version) => {
        setExpandedRows(prev => ({
            ...prev,
            [version]: !prev[version]
        }));
    };

    const hasPatches = (row) => row.patches && row.patches.length > 0;

    return (
        <div className={classes.grid}>
            <div className="returnToHome">
                <Link to={"/"} variant="outlined" size="large" className={classes.backButton}>&lt; Return to Homepage</Link>
            </div>
            <div className={ `container ${classes.containerBlock}` }>
                <div className={classes.releasesHeader}>
                    <VersionsIcon style={{height:'56',width:'56', fill: 'white'}} title="" />
                    <h2 className={classes.h2}>Order Management/Orchestrator - Release Versions</h2>
                </div>
                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="a dense table" size="small" className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell><b>Version Name</b></StyledTableCell>
                                    <StyledTableCell align="right"><b>Support Type</b></StyledTableCell>
                                    <StyledTableCell align="right"><b>Release Date</b></StyledTableCell>
                                    <StyledTableCell align="right"><b>End Of Life</b></StyledTableCell>
                                    <StyledTableCell align="left"><b>Status</b></StyledTableCell>
                                    <StyledTableCell align="center"><b>Release Notes</b></StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data.map((row) => (
                                    <React.Fragment key={row.version}>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <span className={classes.versionCell}>
                                                    {hasPatches(row) ? (
                                                        <IconButton
                                                            className={classes.toggleButton}
                                                            size="small"
                                                            onClick={() => toggleRow(row.version)}
                                                        >
                                                            {expandedRows[row.version] ?
                                                                <KeyboardArrowDownIcon /> :
                                                                <KeyboardArrowRightIcon />
                                                            }
                                                        </IconButton>
                                                    ) : (
                                                        <span className={classes.togglePlaceholder}></span>
                                                    )}
                                                    {row.supportType === "Hotfix" ?
                                                        <i className="tabSpace">{row.version}</i> :
                                                        <b>{row.version}</b>
                                                    }
                                                </span>
                                            </StyledTableCell>
                                            <StyledTableCell align="right">{row.supportType}</StyledTableCell>
                                            <StyledTableCell align="right">{row.releaseDate}</StyledTableCell>
                                            <StyledTableCell align="right">
                                                {row.supportType === "Hotfix" &&
                                                    <i className="tabSpace">{row.endOfLife}</i>
                                                }
                                                {row.supportType !== "Hotfix" &&
                                                    <b>{row.endOfLife}</b>
                                                }
                                            </StyledTableCell>
                                            <StyledTableCell align="left">{row.state}</StyledTableCell>
                                            <StyledTableCell align="center">{row.link && <a target='_new' className={classes.link} href={row.link}>{row.releaseNotes}</a>}</StyledTableCell>
                                        </StyledTableRow>
                                        {/* Render patches if expanded */}
                                        {hasPatches(row) && expandedRows[row.version] && row.patches.map((patch) => (
                                            <StyledTableRow key={patch.version} className={classes.patchRow}>
                                                <StyledTableCell>
                                                    <span className={classes.versionCell}>
                                                        <span className={classes.togglePlaceholder}></span>
                                                        <span className={classes.patchIndent}></span>
                                                        <i>{patch.version}</i>
                                                    </span>
                                                </StyledTableCell>
                                                <StyledTableCell align="right">{patch.supportType}</StyledTableCell>
                                                <StyledTableCell align="right">{patch.releaseDate || '-'}</StyledTableCell>
                                                <StyledTableCell align="right">{patch.endOfLife || '-'}</StyledTableCell>
                                                <StyledTableCell align="left">{patch.state || '-'}</StyledTableCell>
                                                <StyledTableCell align="center">
                                                    {patch.link && <a target='_new' className={classes.link} href={patch.link}>{patch.releaseNotes}</a>}
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </div>
    )
}
export default OrderManagementReleaseVersion;